import Http from '@/services/httpAcademy'

export const listJobTitles = (params) =>
	Http.get('/admin/insights/job-titles', { params })

export const listMappings = (params) =>
	Http.get('/admin/insights/mappings', { params })

export const createMapping = (data) =>
	Http.post('/admin/insights/mappings', data)

export const deleteMapping = (id) =>
	Http.delete(`/admin/insights/mappings/${id}`)
